
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class CustomerSuccessDetail extends Vue {
    private user: any = {};
    private subTab: string = null;

    private mounted() {
      if (this.$route.params.id) {
        this.getUser();
      }
    }

    private async getUser(): Promise<void> {
      this.user = await this.$store.dispatch("admin/customerSuccess/readUser", {
        userId: this.$route.params.id,
      });
      if (this.$route.name === "admin-customer-success-detail") {
        this.$router.replace({ name: "admin-customer-success-companies" });
      }
    }
}
